import React, { useEffect } from 'react'
import { createStackNavigator } from '@react-navigation/stack'
import { HomeScreen } from 'ui/home/home-screen'
import { DiscoveryScreen } from 'ui/discovery/discovery-screen'
import { CategorySelectScreen } from 'ui/discovery/category-select-screen'
import { CategoryDiscoveryScreen } from 'ui/discovery/category-discovery-screen'
import { SearchScreen } from 'ui/discovery/search-screen'
import { PlaceReportScreen } from 'ui/discovery/place-report-screen'
import { UnreportedPlace } from 'infra/type'
import { useCategoryList, usePlaceList } from 'api/hooks'
import { categoryStore } from 'store/category'
import { categorySelectStore } from 'store/category-select'
import { placesStore } from 'store/places'
import { ALL_KOREA_BOUNDS } from 'infra/constant'
import {
  CommonStackParamList,
  renderCommonScreens,
} from 'navigation/common-screen'

// https://reactnavigation.org/docs/typescript/#type-checking-screens
export type HomeStackParamList = {
  HomeScreen: { placeId?: number }
  DiscoveryScreen: {}
  CategorySelectScreen: {}
  CategoryDiscoveryScreen: {}
  SearchScreen: {}
  PlaceReportScreen: { data: UnreportedPlace }
} & CommonStackParamList

const Stack = createStackNavigator<HomeStackParamList>()

export const HomeStack = () => {
  const { data: categoryList } = useCategoryList()
  const { data: placeListData } = usePlaceList(ALL_KOREA_BOUNDS)
  useEffect(() => {
    if (Array.isArray(categoryList)) {
      categoryStore.initData(categoryList)
      categorySelectStore.initData(categoryList)
    } else if (categoryList !== undefined) {
      console.warn('[CategoryList] Ignoring malformed API response')
    }
  }, [categoryList])
  useEffect(() => {
    if (Array.isArray(placeListData?.places)) {
      placesStore.save(placeListData.places)
    } else if (placeListData !== undefined) {
      console.warn('[PlaceList] Ignoring malformed API response')
    }
  }, [placeListData])
  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      <Stack.Screen name='HomeScreen' component={HomeScreen} />
      <Stack.Screen name='SearchScreen' component={SearchScreen} />
      <Stack.Screen name='DiscoveryScreen' component={DiscoveryScreen} />
      <Stack.Screen
        name='CategorySelectScreen'
        component={CategorySelectScreen}
      />
      <Stack.Screen
        name='CategoryDiscoveryScreen'
        component={CategoryDiscoveryScreen}
      />
      <Stack.Screen name='PlaceReportScreen' component={PlaceReportScreen} />
      {renderCommonScreens(Stack)}
    </Stack.Navigator>
  )
}
